import _ from "lodash";

import Cookies from "js-cookie";
// cookie保存的天数
import config from "@/config";

import md5 from "js-md5";
const CryptoJS = require("crypto-js");

const {
  cookieExpires,
  TOKEN_KEY,
  USER_ID_KEY,
  PASSWORD_KEY,
  cookieExpiresForUser
} = config;

export const setToken = token => {
  if (token) Cookies.set(TOKEN_KEY, token, { expires: cookieExpires || 1 });
};

export const getToken = () => {
  const token = Cookies.get(TOKEN_KEY);
  if (token) return token;
  else return false;
};

export const refreshTokenLife = () => {
  setToken(getToken());
};
export const clearToken = () => {
  Cookies.remove(TOKEN_KEY);
};

// encrypt password
export const encryptPasswrod = (userId, password) => {
  let p = md5(password + "{" + userId.toLowerCase() + "}");
  return p;
};

// cache user Account
export const cacheUser = (userId, password) => {
  Cookies.set(USER_ID_KEY, userId, { expires: cookieExpiresForUser || 1 });
  Cookies.set(PASSWORD_KEY, password, { expires: cookieExpiresForUser || 1 });
};

// get cached user Account
export const getCachedUser = () => {
  let userId = Cookies.get(USER_ID_KEY),
    password = Cookies.get(PASSWORD_KEY);

  let p = {
    userId: userId,
    password: password,
    encrypted: false,
    rememberMe: false
  };
  if (userId) {
    p.rememberMe = true;
    p.encrypted = true;
  }

  return p;
};

/**
 * 权鉴
 * @param {*} name 即将跳转的路由name
 * @param {*} access 用户权限数组
 * @param {*} routes 路由列表
 * @description 用户是否可跳转到该页
 */
export const canTurnTo = (name, access, routes) => {
  return true;
};

/**
 * group title + timeframe
 * @param {*} title group title
 * @param {*} dateFrom
 * @param {*} dateTo
 * @description 返回显示的 group title
 */
export const getGroupTitle = (title, dateFrom, dateTo) => {
  return title;
  // return title + " (" + dateFrom + " ~ " + dateTo + ")";
};

// 'Ling Liu' -> 'LL'
export const getInitials = function(string) {
  if (!_.isString(string) && string.length) return "";
  return string
    .split(" ")
    .map(n => n[0])
    .join("");
};

// 'Ling Liu' -> 'L.Ling'
export const formatName = function(string) {
  if (!_.isString(string) && string.length) return "";
  let ary = string.split(" "),
    firstName = ary[0][0],
    lastName = ary[1];
  return firstName + "." + lastName;
  // return string.split(" ").map((n) => n[0]).join("");;
};

/*-------------- Encrypt cookies*/

/** Store encrypted data in the cookie */
const encrypt = (text) =>
  CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(text));
const decrypt = (data) =>
  CryptoJS.enc.Base64.parse(data).toString(CryptoJS.enc.Utf8);

export const getCookie = (key) => {
  const val = Cookies.get(key);
  return val !== undefined ? decrypt(val) : null;
};
export const removeCookie = (key) => {
  Cookies.remove(key);
  const val = Cookies.get(key);
  return val !== null;
};
export const setCookie = (key, value, expiration = undefined) => {
  const item = getCookie(key);
  if (item !== null) {
    removeCookie(key);
  }
  expiration !== undefined
    ? Cookies.set(key, encrypt(value), expiration)
    : Cookies.set(key, encrypt(value));
  return getCookie(key) !== null;
};

/*--------------------------------*/

//version switcher
export const setVersion = (version) => {
  if (version) setCookie("version", version);
};

export const visibleVersion = (versionsArray) => {
  let version = getVersion("version");
  if (!version) version = "HACCP";
  if (versionsArray.includes("ALL")) return true;
  return versionsArray.includes(version);
};
export const getVersion = () => {
  const version = getCookie("version");
  if (version) return version;
  else return false;
};


// WEBPACK FOOTER //
// ./src/libs/util.js